var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, AfterViewInit } from '@angular/core';
import { PreferencesService } from '../../services/preferences.service';
import { HasSubscriptions } from '../has-subscriptions';
import { ListingsService } from '../../services/listings.service';
import { Pagination } from '../../classes/pagination';
import { CommunicationService } from '../../services/communication.service';
import { ListingCategory, ListingTypeMap, SCREEN_SIZE } from '../../classes/enums';
import { MetaTagService } from '../../services/meta-tag.service';
import { ActivatedRoute } from '@angular/router';
import { Filters } from '../../classes/user-preferences';
import { RoutingHistoryService } from '../../services/routing-history.service';
import { HistoryItem } from '../../classes/history-item';
import { TranslateService } from '@ngx-translate/core';
import { OdometerService } from '../../services/odometer.service';
import { UserService } from '../../services/user.service';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { NOTIFICAITON_EMAIL_UNSUBSCRIBE } from '../../classes/analytics-tags';
import { BlogService } from '../../services/blog.service';
import { PreRenderService } from '../../services/pre-render.service';
import { debounceTime, take } from 'rxjs/operators';
import get from 'lodash-es/get';
import { StaticPathPipe } from '../../shared/pipes/static-path.pipe';
import { DomSanitizer } from '@angular/platform-browser';
import { BlogPostSourcePage } from '../../classes/enums';
import { SearchBarComponent } from "../search-bar/search-bar.component";
var LandingPageComponent = /** @class */ (function (_super) {
    __extends(LandingPageComponent, _super);
    function LandingPageComponent(preferencesService, listingsService, communicationService, metaTagsService, activatedRoute, odometerService, prerenderService, historyService, blogService, translateService, staticPathPipe, userService, analyticsService, sanitizer) {
        var _this = _super.call(this) || this;
        _this.preferencesService = preferencesService;
        _this.listingsService = listingsService;
        _this.communicationService = communicationService;
        _this.metaTagsService = metaTagsService;
        _this.activatedRoute = activatedRoute;
        _this.odometerService = odometerService;
        _this.prerenderService = prerenderService;
        _this.historyService = historyService;
        _this.blogService = blogService;
        _this.translateService = translateService;
        _this.staticPathPipe = staticPathPipe;
        _this.userService = userService;
        _this.analyticsService = analyticsService;
        _this.sanitizer = sanitizer;
        _this.showUnsubscribedModal = false;
        _this.pagination = new Pagination();
        _this.suggestedListings = [];
        _this.SCREEN_SIZE = SCREEN_SIZE;
        _this.BlogPostSourcePage = BlogPostSourcePage;
        _this.h1Text = '';
        _this.productSchema = [];
        _this.showBannerStyle = {};
        _this.showVideoStyle = {};
        _this.isScreenSizeGreaterThanTablet = false;
        _this.personas = [{
                url: '/persona/my-first-home',
                image: '/assets/landing_page/persona1.jpg',
                name: 'landing-page-residential.personas.my-first-home'
            }, {
                url: '/persona/our-first-home',
                image: '/assets/landing_page/persona2.jpg',
                name: 'landing-page-residential.personas.our-first-home'
            }, {
                url: '/persona/our-next-home',
                image: '/assets/landing_page/persona3.jpg',
                name: 'landing-page-residential.personas.our-next-home'
            }, {
                url: '/persona/our-right-sized-home',
                image: '/assets/landing_page/persona4.jpg',
                name: 'landing-page-residential.personas.our-right-sized-home'
            }, {
                url: '/persona/our-luxury-home',
                image: '/assets/landing_page/persona5.jpg',
                name: 'landing-page-residential.personas.our-luxury-home'
            }, {
                url: '/persona/our-multi-family-home',
                image: '/assets/landing_page/persona6.jpg',
                name: 'landing-page-residential.personas.our-multi-family-home'
            }];
        return _this;
    }
    LandingPageComponent.prototype.ngAfterViewInit = function () {
        if (this.isResidential) {
            this.odometerService.init('.odometer', 0, this.totalListings || 75000);
        }
    };
    LandingPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Handles reinitialization when switching between province pages.
        this.addSub(this.activatedRoute.data.subscribe(function (data) {
            _this.isCommercial = data.isCommercial;
            _this.isLuxury = data.isLuxury;
            _this.province = data.province;
            _this.isResidential = !_this.isCommercial && !_this.isLuxury;
            _this.searchIcon = _this.getSearchIcon();
            _this.pageConfig = data.pageConfig;
            _this.bannerUrl = !!_this.pageConfig ? _this.pageConfig.heroImageUrl : _this.getBannerUrl();
            _this.setVideoUrl();
            _this.campaignUrl = !!_this.pageConfig && _this.pageConfig.heroCampaignImageUrl ? _this.pageConfig.heroCampaignImageUrl : _this.getCampaignBannerUrl();
            _this.showBannerStyle = _this.addStyles(_this.bannerUrl);
            _this.showVideoStyle = _this.addStyles(_this.campaignUrl);
            if (_this.isCommercial)
                _this.communicationService.setCurrentListingType(ListingCategory.COMMERCIAL, false);
            else if (_this.isLuxury)
                _this.communicationService.setCurrentListingType(ListingCategory.LUXURY, false);
            else
                _this.communicationService.setCurrentListingType(ListingCategory.RESIDENTIAL, false);
            if (_this.province) {
                var filters = new Filters();
                filters.featuredListings = _this.isCommercial ? 'c' : _this.isLuxury ? 'l' : 'r';
                _this.listingsService.searchProvinceCity(_this.province, null, _this.pagination, filters).toPromise().then(function (result) {
                    _this.suggestedListings = result.results;
                });
            }
            else if (_this.prerenderService.isBrowserMode) {
                _this.preferencesService.centerMapAtCurrentLocation();
                _this.preferencesService.doneGettingPhysicalLocation.pipe(debounceTime(100), take(1)).toPromise().then(function (e) { return _this._getListings(e); });
            }
            if (_this.isResidential) {
                _this.listingsService.getListingsCount().toPromise().then(function (count) {
                    // Cache count in server version, but don't render it.
                    if (_this.prerenderService.isBrowserMode)
                        _this.totalListings = count;
                });
                _this.blogService.getByTags(['cms-homepage-1', 'cms-homepage-2', 'cms-homepage-3', 'cms-listing-details-TD']).toPromise()
                    .then(function (results) {
                    if (results) {
                        var tdAd = results.filter(function (obj) { return obj.tag === 'cms-listing-details-TD'; });
                        _this.tdAd = get(tdAd, '[0].content.content.rendered');
                    }
                });
            }
            _this.communicationService.footerLinksChange.next({ city: null, province: data.province });
            _this._setSEOItems();
        }));
        this.addSub(this.communicationService.screenSize.subscribe(function (screenSize) {
            _this.screenSize = screenSize;
            _this.isScreenSizeGreaterThanTablet = screenSize >= SCREEN_SIZE.TABLET_PORTRAIT_UP;
            _this.showBannerStyle = _this.addStyles(_this.bannerUrl);
            _this.showVideoStyle = _this.addStyles(_this.campaignUrl);
            _this.setBannerTitle();
        }));
        this.historyService.push(new HistoryItem());
        if (this.activatedRoute.snapshot.data.unsubscribed) {
            this.userService.unsubscribeSavedSearchNotifications(this.activatedRoute.snapshot.data.unsubscribed)
                .subscribe(function () {
                _this.analyticsService.eventTrack(NOTIFICAITON_EMAIL_UNSUBSCRIBE, null);
                _this.userService.currentUser.subscribe(function (user) {
                    if (user) {
                        user.preferences.savedSearches.forEach(function (saveSearch) {
                            saveSearch.notificationsEnabled = false;
                        });
                        _this.userService.saveUserPreferences(user.preferences);
                    }
                });
                _this.showUnsubscribedModal = true;
            });
        }
    };
    LandingPageComponent.prototype.getBannerUrl = function () {
        if (this.isCommercial)
            return '/assets/landing_page/commercial_hero@3x.jpg';
        if (this.isLuxury)
            return '/assets/landing_page/luxury_hero@3x.jpg';
        return '/assets/landing_page/hero_image@3x.jpg';
    };
    LandingPageComponent.prototype.setVideoUrl = function () {
        var videoUrlArray = !!this.pageConfig && this.pageConfig.heroVideoUrl ? this.pageConfig.heroVideoUrl : [];
        if (videoUrlArray.length) {
            // pick a random url
            var random = Math.floor(Math.random() * (videoUrlArray.length - 1)) + 0;
            this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pageConfig.heroVideoUrl[random]);
        }
        else {
            this.videoUrl = this.getVideoUrl();
        }
    };
    LandingPageComponent.prototype.getVideoUrl = function () {
        return this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/arhajOkf_K4?rel=0');
    };
    LandingPageComponent.prototype.getCampaignBannerUrl = function () {
        return '/assets/landing_page/remax-campaign.jpg';
    };
    LandingPageComponent.prototype.setBannerTitle = function () {
        this.screenSize === SCREEN_SIZE.MOBILE_ONLY ? this.getBannerTitleFirstPart('landing-page-residential.mobile.with-over')
            : this.getBannerTitleFirstPart('landing-page-residential.with-over');
        this.screenSize === SCREEN_SIZE.MOBILE_ONLY ? this.getBannerTitleSecondPart('landing-page-residential.mobile.listings-across-canada')
            : this.getBannerTitleSecondPart('landing-page-residential.listings-across-canada');
    };
    LandingPageComponent.prototype.getBannerTitleFirstPart = function (key) {
        var _this = this;
        this.translateService.get(key).toPromise().then(function (description) { return _this.bannerTitleFirstPart = description; });
    };
    LandingPageComponent.prototype.getBannerTitleSecondPart = function (key) {
        var _this = this;
        this.translateService.get(key).toPromise().then(function (description) { return _this.bannerTitleSecondPart = description; });
    };
    LandingPageComponent.prototype.centerMapAtUserLocation = function () {
        this.preferencesService.centerMapAtCurrentLocation(false, true);
    };
    LandingPageComponent.prototype.addStyles = function (url) {
        var statURL = this.staticPathPipe.transform(url + '?auto=compress,format&q=25');
        if (this.screenSize === SCREEN_SIZE.MOBILE_ONLY) {
            return {
                'background-image': 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),url(' + statURL + ')'
            };
        }
        return {
            'background-image': 'url(' + statURL + ')'
        };
    };
    LandingPageComponent.prototype.getSearchIcon = function () {
        if (this.isCommercial || this.isLuxury)
            return '/assets/landing_page/search_icon@1x.svg';
        return '/assets/landing_page/search_icon_residential@1x.svg';
    };
    LandingPageComponent.prototype._setSEOItems = function () {
        var key = 'meta-tags.';
        var vars = {};
        if (this.province) {
            key += 'province-page';
            vars = {
                province: this.province
            };
        }
        else
            key += 'landing-' + (this.isCommercial ? 'commercial' : (this.isLuxury ? 'luxury' : 'residential'));
        var openGraphTags = [
            {
                name: 'title',
                content: key + '.title',
                variables: vars,
                isTranslateKey: true
            },
            {
                name: 'description',
                content: key + '.description',
                variables: vars,
                isTranslateKey: true
            },
        ];
        if (this.province)
            openGraphTags.push({ name: 'image', content: this.bannerUrl });
        this.metaTagsService.setPageDescription(key + '.description', vars);
        this.metaTagsService.setPageTitle(key + '.title', vars);
        this.metaTagsService.setOpenGraphTags(openGraphTags);
        this._setH1Text(key + '.h1', vars);
    };
    LandingPageComponent.prototype._setH1Text = function (translationName, variables) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!variables) return [3 /*break*/, 2];
                        if (!variables['province']) return [3 /*break*/, 2];
                        _a = variables;
                        _b = 'province';
                        return [4 /*yield*/, this.translateService.get('provinces.' + variables['province']).toPromise()];
                    case 1:
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2:
                        this.translateService.get(translationName, variables).toPromise().then(function (description) { return _this.h1Text = description; });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Retrieve listings to display
     * 1) if we know the location we'll get location specific listings
     * 2) if we dont know the location, we'll get canadian wide listings
     */
    LandingPageComponent.prototype._getListings = function (e) {
        var _this = this;
        var filters = new Filters();
        var distance = 100000;
        filters.featuredListings = this.isCommercial ? 'c' : this.isLuxury ? 'l' : 'r';
        if (this.isCommercial) {
            filters.customListingTypeIds = ListingTypeMap.commercial.slice();
        }
        if (this.isLuxury) {
            this.pagination.limit = 2;
            distance = 10000000; // not so arbitrarily high number
        }
        if (e[0]) {
            this.preferencesService.positionInfoChanged.pipe(take(1)).toPromise().then(function (newPosition) {
                _this.listingsService.getListingsByDistanceFrom(_this.pagination, filters, newPosition.centerLatLng, distance).then(function (listings) {
                    _this.suggestedListings = listings.results;
                    _this.productSchema = _this.listingsService.checkForProductValues(_this.suggestedListings);
                });
            });
        }
        else {
            this.listingsService.searchProvinceCity(null, null, this.pagination, filters).pipe(take(1)).toPromise().then(function (listings) {
                _this.suggestedListings = listings.results;
                _this.productSchema = _this.listingsService.checkForProductValues(_this.suggestedListings);
            });
        }
    };
    return LandingPageComponent;
}(HasSubscriptions));
export { LandingPageComponent };
